export default [
  {
    prop: 'client_name',
    label: '客户名称',
    className: 'text_align_left'
  },
  {
    prop: 'total_money',
    label: '累计支付金额'
  },
  {
    prop: 'no1',
    label: '158565458商户支付'
  },
  {
    prop: 'no2',
    label: '158565458商户支付'
  },
  {
    prop: 'no3',
    label: '158565458商户支付'
  }
]
